export default __webpack_public_path__ + "static/media/icon-clock-fill3.bdfb21d3.svg";